import { render, staticRenderFns } from "./FileShareSearchView.vue?vue&type=template&id=2bed17c9&scoped=true"
import script from "./FileShareSearchView.vue?vue&type=script&lang=js"
export * from "./FileShareSearchView.vue?vue&type=script&lang=js"
import style0 from "./FileShareSearchView.vue?vue&type=style&index=0&id=2bed17c9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bed17c9",
  null
  
)

export default component.exports